import { forwardRef, type HTMLAttributes } from "react"
import { cn } from "src/utils/Functions"

const rootStyles =
  "rounded-2xl border-2 border-border dark:border-neutral-800 flex flex-col shadow-xs overflow-hidden"

const headerStyles =
  "bg-neutral-100 dark:bg-neutral-800 flex items-center justify-between min-h-12 p-2 border-b border-border dark:border-border/60"

const contentWrapperStyles =
  "p-3 flex flex-col bg-neutral-100 dark:bg-neutral-900"

export const WidgetCardRoot = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function WidgetCardRoot({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(rootStyles, className)}
      {...props}
    />
  )
})

export function WidgetCardHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(headerStyles, className)} {...props} />
}

export function WidgetCardContent({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={contentWrapperStyles}>
      <div className={cn("flex flex-col", className)} {...props} />
    </div>
  )
}

export const WidgetCard = Object.assign(WidgetCardRoot, {
  Header: WidgetCardHeader,
  Content: WidgetCardContent,
})
